import * as React from 'react';
import classNames from 'classnames';
import './Grid.scss';

export interface IColumnProps {
  children?: {};
  className?: string;
  alignSelf?: 'start' | 'center' | 'end';
  style?: React.CSSProperties;
  sm?: number | 'auto' | 'fill';
  md?: number | 'auto' | 'fill';
  lg?: number | 'auto' | 'fill';
  xl?: number | 'auto' | 'fill';
}

export const Column = ({ 
  children, 
  className,
  alignSelf,
  style,
  sm, 
  md, 
  lg,
  xl
}: IColumnProps) => (
  <div 
    style={style}
    className={classNames(
      'column',
      className,
      alignSelf && `align-self-${alignSelf}`,
      sm && `is-sm-${sm}`,
      md && `is-md-${md}`,
      lg && `is-lg-${lg}`,
      xl && `is-xl-${xl}`
    )}
  >
    {children}
  </div>
);

interface IColumnsProps {
  children?: {};
  style?: React.CSSProperties;
  gutter?: '' | 'default' | 'large';
  alignItems?: '' | 'start' | 'center' | 'end';
  className?: string;
}

export const Columns = ({ 
  children, 
  style, 
  gutter, 
  className,
  alignItems
}: IColumnsProps) => (
  <div 
    style={style}
    className={classNames(
      'columns',
      gutter && `has-${gutter}-gutter`,
      alignItems && `items-${alignItems}`,
      className
    )
  }>
    {children}
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Layout/Grid.tsx